import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/activateNewUser`;

export default {
    get(data) {},
    create(data) {
        return axios.post(API, data);
    }
};